import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { retirosApi } from '../api/remitos'
import { fmtFecha } from '../utils/fecha'
import Boton from '../components/Boton'

/**
 * Lista para separar — el papel con el que el depósito separa por la mañana
 * lo que cada sucursal tiene pendiente de retiro (Retiros por sucursal → 🖨).
 * Se abre en otra pestaña, fuera del layout, y se imprime con el botón.
 * Remito, cliente, renglones, unidades y un casillero por fila.
 */
export default function RetirosListaPage() {
  const [params] = useSearchParams()
  const sucursalId = params.get('sucursal') || ''
  const [data, setData] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    retirosApi.listar()
      .then(res => setData(res.data))
      .catch(e => setError(e.response?.data?.message || 'No se pudo cargar la lista.'))
  }, [])

  if (error) return <div style={css.page}><p style={{ color: '#991b1b' }}>{error}</p></div>
  if (!data) return <div style={css.page}><p style={{ color: '#64748b' }}>Cargando…</p></div>

  const sucursal = (data.sucursales || []).find(s => s.id === sucursalId) || null
  const lista = (data.pendientes || [])
    .filter(r => !sucursal || r.sucursal?.id === sucursal.id)
    .sort((a, b) => (a.cliente?.nombre || '').localeCompare(b.cliente?.nombre || ''))
  const unidades = lista.reduce((acc, r) => acc + (Number(r.unidades) || 0), 0)
  const hoy = fmtFecha(new Date().toISOString())

  return (
    <div style={css.page}>
      <div className="no-print" style={css.barra}>
        <Boton variante="secondary" sm onClick={() => window.print()}>🖨 Imprimir</Boton>
        <Boton variante="ghost" sm onClick={() => window.close()}>Cerrar</Boton>
      </div>
      <style>{'@media print { .no-print { display: none } body { background: #fff } @page { margin: 14mm } }'}</style>

      <div style={css.papel}>
        <h1 style={css.h1}>LISTA PARA SEPARAR — {sucursal ? sucursal.nombre.toUpperCase() : 'TODAS LAS SUCURSALES'}</h1>
        <div style={css.meta}>{sucursal ? `${sucursal.direccion} · ` : ''}{hoy} · {lista.length} remito{lista.length !== 1 ? 's' : ''} · {unidades} unidades</div>

        {lista.length === 0 ? (
          <p style={{ color: '#64748b', margin: '16px 0' }}>No hay retiros pendientes{sucursal ? ` en ${sucursal.nombre}` : ''}.</p>
        ) : (
          <table style={css.tabla}>
            <thead>
              <tr>
                <th style={{ ...css.th, width: 28 }} />
                <th style={css.th}>Remito</th>
                <th style={css.th}>Cliente</th>
                {!sucursal && <th style={css.th}>Sucursal</th>}
                <th style={{ ...css.th, textAlign: 'right' }}>Rengl.</th>
                <th style={{ ...css.th, textAlign: 'right' }}>Unid.</th>
                <th style={css.th}>Aviso</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(r => (
                <tr key={r.id}>
                  <td style={css.td}><span style={css.cb} /></td>
                  <td style={{ ...css.td, ...css.mono, fontWeight: 700 }}>{r.numero_presea || r.numero || '—'}</td>
                  <td style={css.td}>{r.cliente?.nombre || '—'}</td>
                  {!sucursal && <td style={css.td}>{r.sucursal?.nombre || '—'}</td>}
                  <td style={{ ...css.td, ...css.mono, textAlign: 'right' }}>{r.renglones}</td>
                  <td style={{ ...css.td, ...css.mono, textAlign: 'right' }}>{r.unidades}</td>
                  <td style={css.td}>{r.disponible_retiro_at ? <>avisado <span style={css.mono}>{fmtFecha(r.disponible_retiro_at)}</span></> : <b>sin avisar</b>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div style={css.banda}>RETIRA EL CLIENTE · NO DESPACHAR · SEPARAR POR SUCURSAL</div>
      </div>
    </div>
  )
}

const css = {
  page: { background: '#f1f5f9', minHeight: '100vh', padding: 24, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif', color: '#0f172a', fontSize: 13 },
  barra: { display: 'flex', gap: 8, marginBottom: 16, maxWidth: 760, marginLeft: 'auto', marginRight: 'auto' },
  papel: { background: '#fff', border: '1px solid #0f172a', padding: '18px 20px', maxWidth: 760, margin: '0 auto' },
  h1: { margin: 0, fontSize: 16, letterSpacing: '0.02em' },
  meta: { color: '#64748b', fontSize: 12, margin: '4px 0 12px' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: 12.5 },
  th: { textAlign: 'left', borderBottom: '2px solid #0f172a', padding: '6px 4px', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.05em' },
  td: { padding: '7px 4px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'middle' },
  mono: { fontFamily: 'ui-monospace, "SF Mono", Menlo, Monaco, Consolas, monospace', fontVariantNumeric: 'tabular-nums' },
  cb: { width: 14, height: 14, border: '1.5px solid #0f172a', display: 'inline-block', verticalAlign: 'middle' },
  banda: { marginTop: 14, background: '#0f172a', color: '#fff', fontWeight: 700, letterSpacing: '0.06em', textAlign: 'center', padding: 6, fontSize: 11.5, textTransform: 'uppercase' },
}
